var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((_vm.history),function(item,idx){return _c('HistoryItem',{key:("history-item-" + idx),attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }